export enum Role {
  Admin = 'CustomerPortal.AdminSite.Access',
  WarrantyApprovalAdmin = 'CustomerPortal.WarrantyApprovalAdmin',
  GenesigReleaseManager = 'CustomerPortal.Genesig.ReleaseManager'
}
